<template>
	<div class="magtop60">
		<div class="msg_box" v-html="th"></div>
	</div>
</template>

<script>
export default{
	data(){
		return{
			th:''
		}
	},
	created(){
		this.PostuserCommon();
	},
	methods:{
		async PostuserCommon(){
			let {data} = await this.api.PostuserCommon({name:'registration_protocol'});
			this.th = data;
		}
	}
}
</script>

<style lang="scss" scoped >
.msg_box{
	line-height: 1.8em;
}
</style>
